import React, { useState } from 'react'

const useForm = (initialState) => {
    const [values, setValues] = useState(initialState)

    const handleChange = event => {
        // maintenir en memoire
        event.preventDefault()
        setValues(prevValues => ({
            ...prevValues,
            [event.target.name]: event.target.value
        }))
    }

    // remettre a zero
    const refresh = () => {
        setValues(initialState)
        console.log('useForm refresh ',)
    }

    return { handleChange, values, refresh, setValues }
}

export default useForm
